import { UserGroup } from 'common/types/Entities';

import { _request, APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUPS_PATH_PREFIX = 'usergroups';
const USER_GROUPS_COUNTS_PATH_PREFIX = 'counts';

type APIUserGroupsListParams = RequestParamsBase & {
    tenantId: string;
};

type APIUserGroupsListResponse = APIBaseResponse<Array<UserGroup>>;

type APIUserGroupsPostParams = {
    tenantId: string;
    name: string;
    description: string;
}

type APIUserGroupsPutParams = {
    tenantId: string;
    name: string;
    description: string;
    id: string;
}

type APIUserGroupsPostResponse = APIBaseResponse<{
    userGroupId: string;
}>;

export const APIUserGroupsGetList: APIMethod<APIUserGroupsListParams, APIUserGroupsListResponse> = (params: APIUserGroupsListParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}`, undefined, params.signal)
);

type APIUserGroupGetParams = {
    id: string;
    tenantId: string;
};

export type APIUserGroupGetResponse = APIBaseResponse<{
    tenantId: string;
    id: string;
    name: string;
    description: string;
}>;

export type APIUserGroupWithCountsGetResponse = APIBaseResponse<Array<{
    groupId: string;
    name: string;
    userCount: number;
    packageCount: number;
    resourceAccesses: {
        resourceId: string,
        accesses: string[]
    }[];
    cibs: string[];
}>>;

type APIUserGroupDeleteParams = {
    id: string;
    tenantId: string;
}

export const APIUserGroupGet: APIMethod<APIUserGroupGetParams, APIUserGroupGetResponse> = (params: APIUserGroupGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}/${params.id}`)
);

export const APIUserGroupWithCountsGetList: APIMethod<string, APIUserGroupWithCountsGetResponse> = (tenantId: string) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${tenantId}/${USER_GROUPS_PATH_PREFIX}/${USER_GROUPS_COUNTS_PATH_PREFIX}`)
);

export const APIUserGroupPost: APIMethod<APIUserGroupsPostParams, APIUserGroupsPostResponse> = (params: APIUserGroupsPostParams) => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}`, {
        tenantId: params.tenantId,
        name: params.name,
        description: params.description,
    })
);

export const APIUserGroupDelete: APIMethod<APIUserGroupDeleteParams, APIBaseResponse> = (params: APIUserGroupDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}/${params.id}`));

export const APIUserGroupPut: APIMethod<APIUserGroupsPutParams, APIBaseResponse> = (params: APIUserGroupsPutParams) => (
    _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}/${params.id}`, {
        tenantId: params.tenantId,
        name: params.name,
        description: params.description,
        id: params.id
    })
);
